import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { PageResultDto, RecommendationSearchFields } from '../../common/viewModels/GlobalRegistry/UnitsModel';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../common/pagerService';
import { ValidationService } from '../../common/validationservice';
declare var $: any;

@Component({
  selector: 'recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss']
})

export class Recommendations implements OnInit {
  addrecommendationForm: FormGroup;
  recommendationSearchForm: FormGroup;
  id: number;
  searchFields: RecommendationSearchFields = new RecommendationSearchFields();
  isNoRecords: boolean = true;
  isSubmitted: boolean = false;
  pager: any = {};
  pagedItems: any[];
  pageResult: PageResultDto;
  length: number = 0;
  mainComponent: any;
  lstSampleTypes: any[];
  $element: any;
  $content: any;

  constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService,
    private _validationSrvc: ValidationService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.CreateForm();
    this.recommendationSearchForm = this._formBuilder.group({
      Recommendation: [''],
      SampleTypeId: [0],
      RecommendationId: [0],
    });
    this.BindStaticSearchData();
    this.setPage(this.pager);
    this.GetSampleTypes();
  }

  CreateForm() {
    this.addrecommendationForm = this._formBuilder.group({
      RecommendationId: [0],
      SampleTypeId: [0, Validators.compose([Validators.required, this._validationSrvc.ValidateDropdownList])],
      Recommendation: ['', Validators.compose([Validators.required])],
    });
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.pageSize;
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetRecommendationsList(this.pager);
  }

  GetRecommendationsList(page: any) {
    
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetRecommendationsList, this.searchFields)
      .subscribe(
      res => {
        var data = res.json();
        this.length = data.PageResult.TotalRecords;
        this.pagedItems = data.Result;
        this.isNoRecords = !(data.Result.length > 0);
        this._mApp.HideLoader();
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetRecommendationById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetRecommendationById + id)
      .subscribe(
      m => {
        this._mApp.HideLoader();
        if (m.json().Result != null) {
          this.addrecommendationForm.setValue(m.json().Result);
        }
      }, error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      )
  }

  DeleteRecommendation(id: any) {
    this.id = id;
  }

  DeleteRecommendationById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteRecommendation + id)
      .subscribe(
      res => {
        this._mApp.HideLoader();
        this.setPage(this.pager);
        this._toastrService.success(res.json().Result, '');

      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  onSearchSubmit() {
    
    this.pager.pageIndex = 0;
    let searchDto = this.recommendationSearchForm.value;
    if (searchDto.Recommendation != null)
      this.searchFields.Recommendation = searchDto.Recommendation;
    if (searchDto.SampleTypeId > 0)
      this.searchFields.SampleTypeId = searchDto.SampleTypeId;
    this.setPage(this.pager);
  }

  onSubmit() {

    this.addrecommendationForm.get('Recommendation').setValidators(Validators.compose([Validators.required]));
    this.addrecommendationForm.get('Recommendation').updateValueAndValidity();
    this.addrecommendationForm.get('SampleTypeId').setValidators(Validators.compose([Validators.required, this._validationSrvc.ValidateDropdownList]));
    this.addrecommendationForm.get('SampleTypeId').updateValueAndValidity();
    this.isSubmitted = true;
    if (this.addrecommendationForm.valid) {
      let recDto = this.addrecommendationForm.value;
      this._mApp.ShowLoader();
      if (recDto.RecommendationId == null || recDto.RecommendationId == 0) {
        recDto.RecommendationId = 0;
      }
      this._http.post(this._appUrl.UpsertRecommendation, recDto)
        .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          $('#addRecommendationModel').modal('toggle');
          this.Clear();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
        );
    }
    else {

    }
  }

  Clear() {
    this.addrecommendationForm.get('Recommendation').setValidators(Validators.compose([Validators.required]));
    this.addrecommendationForm.get('Recommendation').updateValueAndValidity();
    this.addrecommendationForm.get('SampleTypeId').setValidators(Validators.compose([Validators.required, this._validationSrvc.ValidateDropdownList]));
    this.addrecommendationForm.get('SampleTypeId').updateValueAndValidity();
    this.addrecommendationForm.reset();
  }

  OnReset() {
    this.recommendationSearchForm.reset();
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.searchFields.Recommendation = '';
    this.searchFields.SampleTypeId = 0;
    this.setPage(this.pager);
  }

  GetSampleTypes() {
    this._http.get(this._appUrl.GetMinInfoSampleTypes)
      .subscribe(
      data => {
        if (data.json().Result != null) {
          this.lstSampleTypes = data.json().Result;
          this.lstSampleTypes = this.lstSampleTypes.filter(m => m.SampleTypeId != 3);
        }
      },
      error => {
        this._toastrService.error(error.json().Result);
      }
      )
  }
} 